export const SHOW_UP_ARROW = 'showUpArrows';
export const SHOW_DOWN_ARROW = 'showDownArrows';
export const SHOW_NO_ARROWS = 'showNoArrows';
export const SHOW_BOTH_ARROWS = 'showBothArrows';
